import { Card, makeStyles, Theme, useMediaQuery } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { CustomTheme } from '../../appTemplates/MUIProviderTemplate/MUIProviderTemplateInterfaces';
import { RootStore } from '../../store/reducers';
import { languageSelector } from '../../store/selectors/appSelectors';
import { headerSelector } from '../../store/selectors/globalConfigSelectors';
import { getTranslation } from '../../utils/functions';
import styles from './TitleCard.module.scss';

const useCardStyles = (isMobileView: boolean) =>
  makeStyles((theme: CustomTheme) => ({
    root: {
      boxShadow: theme.shadows[3],
      padding: isMobileView ? 20 : '20px 40px',
      minHeight: 100,
      position: 'relative',
      top: 5,
    },
    container: {
      height: '100%',
      display: 'flex',
      flexDirection: isMobileView ? 'column' : 'row',
      alignItems: 'center',
    },
    separator: {
      margin: `0 ${theme.spacing(2)}px`,
      color: theme.palette.grey[600],
    },
  }));

const TitleCard: React.FC = () => {
  const { header, language } = useSelector((state: RootStore) => ({
    header: headerSelector(state),
    language: languageSelector(state),
  }));
  const [detectChangeLanguage, setDetectChangeLanguage] = useState(true);

  const isMobileView = useMediaQuery((theme: Theme) => theme.breakpoints.down('xs'));

  const classes = useCardStyles(isMobileView)();

  const separator = isMobileView ? null : <div className={classes.separator}>|</div>;

  useEffect(() => {
    setDetectChangeLanguage(true);
  }, [language]);
  return (
    <>
      {detectChangeLanguage && (
        <Card className={classes.root}>
          <div className={classes.container}>
            <img src={header?.logoUrl} alt="" className={styles.logo} />
            {separator}

            <h2 className={styles.title}>{getTranslation(header?.logoHeaderText)}</h2>
          </div>
        </Card>
      )}
    </>
  );
};

export default TitleCard;
